export default __webpack_public_path__ + "static/media/logo sport.45a67a21.png";